import { useEffect, useState } from "react";

import FullScreenTakeover from "@musicfy/components/FullScreenTakeover";

import {
  SETTINGS_PANEL_INFO,
  SettingsPanel,
  type TSettingsPanel,
} from "./types";

interface AccountSettingsProps {
  isOpen: boolean;
  onClose: () => void;
  initialPanel?: TSettingsPanel;
}

const AccountSettings = ({
  isOpen,
  onClose,
  initialPanel = SettingsPanel.general,
}: AccountSettingsProps): JSX.Element => {
  const [activePanel, setActivePanel] = useState<TSettingsPanel>(initialPanel);

  useEffect(() => {
    if (isOpen) {
      setActivePanel(initialPanel);
    }
  }, [initialPanel, isOpen]);

  const Panel = SETTINGS_PANEL_INFO[activePanel].Panel;

  return (
    <FullScreenTakeover open={isOpen} onClose={onClose}>
      <Panel setActivePanel={setActivePanel} onClose={onClose} />
    </FullScreenTakeover>
  );
};

export default AccountSettings;
